import { LineChart, Line, CartesianGrid, XAxis, YAxis } from 'recharts';
import React from "react";
const data = [
    {name: 'A', uv: 0, amt: 10},
    {name: 'B', uv: 0, amt: 1},
    {name: 'C', uv: 0, amt: 1},
    {name: 'D', uv: 0, amt: 1},
];

class COGraph extends React.Component {
    render() {
        return (
            <LineChart width={160} height={150} data={data}>
                <Line type="monotone" dataKey="uv" stroke="#F99999" strokeWidth="5"/>
                <CartesianGrid stroke="#ccc" />
                <XAxis label="CO" dy={50}/>
                <YAxis />
            </LineChart>
        );
    }
}


export default COGraph;
